import PropTypes from "prop-types";
import { Col, Form, Input, Row, Select, Tooltip } from "antd";
import FormItem from "antd/lib/form/FormItem";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import Calendar from '../../../../../CommonComponents/Calendar/Calendar';
import { TitleTextWrapper, InputField } from '../../../../../CommonComponents/commonStyles';
import { handleInfoChange, jsonTemp, prefillValuesInfoPrimary, prefillValuesInfoSecondary, savePrimaryInfo } from "../../../actions";
import { filterGenderData, filterGenderDesc, filterSuffixData, filterSuffixDesc, filterTitleData, filterTitleDesc } from "../../Data/DropDownData";
import { CalenderDisabling, Err, InputWrapper, InputWrapperDrop, InputWrapperGraded, NoResultsWrap, RowWrapper, SecurityNumWrap, SelectdropwownStyles, SelectOptionGenderWrapper, SelectOptionMainWrapper, SelectOptionWrapper, TitleMarginTop, TitleWrapper, TitleWrapperTitle, TooltipTextwrap, WrapLabel } from "../styles";

class userInfoForm extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      //used for errors
      firstname: null,
      lastname: null,
      dob: null,
      ssn: null,
      confirmSSN: null,
      gender: null
    };
    this.titleValue = "";
    this.suffixValue = "";
    this.genderValue = "";
  }
  componentDidUpdate() {
    if (this.props.isStep1Edit) {
      this.props.enableResetButton();
    }
  }
   
  text = (<TooltipTextwrap>Last four digits of SSN or PIN.</TooltipTextwrap>);
  advisorType = this.props.advisorType;
  userType = this.props.userType;
  focus = e => {
    let val;
    const advisorData = this.advisorType === "Primary" ? this.props.primaryInfo : this.props.secondaryInfo;
    if (this.props.isStep1Edit) {
      val = this.props.tempData.tempJSON.advisors[1];
    } else {
      val = advisorData;
    }
    if (e === "First Name") {
      if (val.firstname.length < 1) {
        this.setState({ firstname: <Err>Please enter first name.</Err> });
      } else if (this.advisorType === "Secondary" && this.props.addSecondaryAdv && val.firstname.length < 2) {
        this.setState({ firstname: <Err>First name is too short.</Err> });
      } else {
        this.setState({ firstname: null });
      }
    } else if (e === "Last Name") {
      if (val.lastname.length < 1) {
        this.setState({ lastname: <Err>Please enter last name.</Err> });
      } else if (this.advisorType === "Secondary" && this.props.addSecondaryAdv && val.lastname.length < 2) {
        this.setState({ lastname: <Err>Last name is too short.</Err> });
      } else {
        this.setState({ lastname: null });
      }
    } else if (e === "ssn") {
      if (val.ssn.length < 1) {
        this.setState({ ssn: <Err>Please enter your social security number or PIN.</Err> });
      } else if (val.ssn.length < 4) {
        this.setState({
          ssn: <Err>Last four digits of SSN or PIN must be four characters of length</Err>
        });
      } else {
        if (val.confirmSSN.length === 4) {
          if (val.ssn === val.confirmSSN) {
            this.setState({ confirmSSN: null });
          } else {
            this.setState({
              confirmSSN: <Err>Social security numbers or PINs do not match. Please try again.</Err>
            });
          }
        }
      }
    } else if (e === "confirmSSN") {
      if (val.confirmSSN.length < 1) {
        this.setState({
          confirmSSN: <Err>Please re-enter last four digits of SSN/PIN.</Err>
        });
      } else if (val.confirmSSN.length < 4) {
        this.setState({
          confirmSSN: <Err>Social security numbers or PINs do not match. Please try again.</Err>
        });
      } else {
        this.setState({ confirmSSN: null });
      }
      if (val.confirmSSN.length === 4) {
        if (val.ssn !== val.confirmSSN) {
          this.setState({
            confirmSSN: <Err>Social security numbers or PINs do not match. Please try again.</Err>
          });
        } else {
          this.setState({ confirmSSN: null });
        }
      }
    }
  };

  handleSelectChange = (e, val, advisorType) => {
    let tempData;
    let index = 0;
    if (this.props.isStep1Edit) {
      tempData = this.props.tempData.tempJSON;
      if (advisorType === "primaryAdvisor") {
        index = 0;
      } else {
        index = 1;
      }
    }
    if (advisorType === "primaryAdvisor") {
      if (val === "titleEditable" || val === "title") {
        let value = filterTitleDesc(e, this.props.titleDropDown);
        this.props.savePrimaryInfo({ ["title"]: value[0].value });
      } else if (val === "suffixEditable" || val === "suffix") {
        let value = filterSuffixDesc(e, this.props.suffixDropDown);
        this.props.savePrimaryInfo({ ["suffix"]: value[0].value });
      } else if (val === "gender") {
        let value = filterGenderDesc(e, this.props.genderDropDown);
        this.props.savePrimaryInfo({ ["gender"]: value[0].value });
      }
    } else if (advisorType === "secondaryAdvisor") {
      if (val === "titleEditable" || val === "title") {
        let value = filterTitleDesc(e, this.props.titleDropDown);
        this.props.handleInfoChange({ ["title"]: value[0].value });
      } else if (val === "suffixEditable" || val === "suffix") {
        let value = filterSuffixDesc(e, this.props.suffixDropDown);
        this.props.handleInfoChange({ ["suffix"]: value[0].value });
      } else if (val === "gender") {
        let value = filterGenderDesc(e, this.props.genderDropDown);
        this.props.handleInfoChange({ ["gender"]: value[0].value });
      }
    }
  };
  handleNameChange = (e, type, advisorType) => {
    let tempData;
    let index = 0;
    if (this.props.isStep1Edit) {
      tempData = this.props.tempData.tempJSON;
      if (advisorType === "primaryAdvisor") {
        index = 0;
      } else {
        index = 1;
      }
    }
    if (e.target.value.length > 0) {
      if (type === "firstname") {
        this.setState({ [type]: null });
      } else if (type === "lastname") {
        this.setState({ [type]: null });
      } else if (type === "ssn") {
        this.setState({ [type]: null });
      } else if (type === "confirmSSN") {
        this.setState({ [type]: null });
      }
    } else {
      this.setState({ [type]: null });
    }
    if (type === "firstname" || type === "lastname" || type === "middlename") {
      let reg = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{0,150}$/;
      if (reg.test(e.target.value)) {
        if (advisorType === "primaryAdvisor") {
          this.props.savePrimaryInfo({ [type]: e.target.value });
        } else {
          this.props.handleInfoChange({ [type]: e.target.value });
        }
      }
    } else if (type === "ssn" || type === "confirmSSN") {
      let reg = /^[a-zA-Z0-9]{0,4}$/;
      if (reg.test(e.target.value)) {
        if (advisorType === "primaryAdvisor") {
          this.props.savePrimaryInfo({ [type]: e.target.value });
        } else {
          this.props.handleInfoChange({ [type]: e.target.value });
        }
      }
    }
  };
  onFocusDOB = e => {
    let val;
    const advisorData = this.advisorType === "Primary" ? this.props.primaryInfo : this.props.secondaryInfo;
    if (this.props.isStep1Edit) {
      val = this.props.tempData.tempJSON.advisors[1];
    } else {
      val = advisorData;
    }
    if (!val.dob) {
      this.setState({ dob: <Err>Please enter date of birth.</Err> });
    } else {
      this.setState({ dob: null });
    }
  };
  handleDOBChange = (e, val, advisorType) => {
    let dateselec = e;
    let currentDate = moment();
    if (currentDate >= e) {
      if (advisorType === "primaryAdvisor") {
        this.props.savePrimaryInfo({ [val]: e });
      } else {
        this.props.handleInfoChange({ [val]: e });
      }
    }
    this.setState({ dob: null });
  };
  handleError = (ssn, confirmSSN) => {
    if (ssn && confirmSSN) {
      if (ssn.split("").length === 4 && confirmSSN.split("").length === 4) {
        if (ssn !== confirmSSN) {
          return <Err>Social security numbers or PINs do not match. Please try again.</Err>;
        }
      }
    }
  };
  resetErrorValues = () => {
    this.setState({
      firstname: null,
      lastname: null,
      dob: null,
      ssn: null,
      confirmSSN: null,
      gender: null
    });
  };
  render() {
    let advisor;
    if (this.advisorType === "Primary") {
      advisor = "primaryAdvisor";
    } else {
      advisor = "secondaryAdvisor";
    }
    if (this.props.resetErrors) {
      this.props.disableReset("userInfo");
      this.resetErrorValues();
    }
    const advisorData = this.advisorType === "Primary" ? this.props.primaryInfo : this.props.secondaryInfo;
    if (this.props && this.props.primaryInfo && this.props.titleDropDown && this.props.suffixDropDown) {
      const suf = filterSuffixData(advisorData.suffix, this.props.suffixDropDown);
      const title = filterTitleData(advisorData.title, this.props.titleDropDown);
      if (title.length <= 0) {
        title.push({ desc: "--" });
      }
      if (suf.length <= 0) {
        suf.push({ desc: "--" });
      }
      this.titleValue = title[0].desc;
      this.suffixValue = suf[0].desc;
      const gender = filterGenderData(advisorData.gender, this.props.genderDropDown);
      if (gender.length > 0) {
        this.genderValue = gender[0].desc;
      } else {
        this.genderValue = "- Select -";
      }
    }
    let titleComponent = "";
    let suffixComponent = "";
    const { getFieldDecorator } = this.props.form;
    let titleArr = this.props.titleDropDown && this.props.titleDropDown.map(freq => freq.desc);
    let titleData = Array.from(new Set(titleArr));
    const addSecondaryAdv = this.props.hasOwnProperty("addSecondaryAdv") ? this.props.addSecondaryAdv : false;
    if (
      (this.advisorType === "Primary" && this.userType === "primary" && !addSecondaryAdv) ||
      (this.advisorType === "Secondary" && this.userType === "secondary") ||
      (this.advisorType === "Secondary" && this.props.isNewSecondaryAdd === true)
    ) {
      titleComponent = (
        <SelectdropwownStyles>
          <div id={"titleEditable" + this.advisorType} style={{ position: "relative" }}>
            <Select
              data-test="selectTitle"
              aria-label="title"
              role={false}
              onChange={e => this.handleSelectChange(e, "titleEditable", advisor)}
              getPopupContainer={() => document.getElementById("titleEditable" + this.advisorType)}
              notFoundContent={<NoResultsWrap>No results</NoResultsWrap>}
              defaultValue={-1}
              value={this.titleValue}
              showSearch
              placeholder="Select title"
            >
              {titleData
                ? titleData.map((freq, index) => {
                    return (
                      <Select.Option value={freq} key={freq + index}>
                        <SelectOptionWrapper>{freq}</SelectOptionWrapper>
                      </Select.Option>
                    );
                  })
                : null}
            </Select>
          </div>
        </SelectdropwownStyles>
      );
      suffixComponent = (
        <SelectdropwownStyles>
          <div id={"suffixEditable" + this.advisorType} style={{ position: "relative" }}>
            <Select
              data-test="suffix-block"
              aria-label="suffix"
              role={false}
              onChange={e => this.handleSelectChange(e, "suffixEditable", advisor)}
              getPopupContainer={() => document.getElementById("suffixEditable" + this.advisorType)}
              notFoundContent={<NoResultsWrap>No results</NoResultsWrap>}
              defaultValue={-1}
              value={this.suffixValue}
              showSearch
              placeholder="Select suffix"
            >
              {this.props.suffixDropDown
                ? this.props.suffixDropDown.map((freq, index) => (
                    <Select.Option value={freq.desc} key={freq.desc + index}>
                      <SelectOptionWrapper>{freq.desc}</SelectOptionWrapper>
                    </Select.Option>
                  ))
                : null}
            </Select>
          </div>
        </SelectdropwownStyles>
      );
    } else {
      titleComponent = (
        <Select
          aria-label="title"
          role={false}
          notFoundContent={<NoResultsWrap>No results</NoResultsWrap>}
          defaultActiveFirstOption={false}
          disabled
          onChange={e => this.handleSelectChange(e, "title", advisor)}
          defaultValue={-1}
          value={this.titleValue}
          placeholder="Select title"
        >
          {this.props.titleDropDown
            ? this.props.titleDropDown.map(freq => <Select.Option value={freq.desc}>{freq.desc}</Select.Option>)
            : null}
        </Select>
      );
      suffixComponent = (
        <Select
          aria-label="suffix"
          role={false}
          notFoundContent={<NoResultsWrap>No results</NoResultsWrap>}
          disabled
          defaultValue={-1}
          value={this.suffixValue}
          placeholder="Select suffix"
        >
          {this.props.suffixDropDown
            ? this.props.suffixDropDown.map(freq => <Select.Option value={freq.desc}>{freq.desc}</Select.Option>)
            : null}
        </Select>
      );
    }
    return (
      <div>
        <Row gutter={24}>
          <Col lg={{ span: 7 }} md={{ span: 9 }}>
            <WrapLabel>
              <FormItem colon={false} label={<TitleWrapperTitle>Title (optional)</TitleWrapperTitle>}>
                {getFieldDecorator(`${"title"}` + this.advisorType, {
                  rules: [
                    {
                      type: "string"
                    }
                  ]
                })(
                  (this.advisorType === "Primary" && this.userType === "primary" && !addSecondaryAdv) ||
                    (this.advisorType === "Secondary" && this.userType === "secondary") ||
                    (this.advisorType === "Secondary" && this.props.isNewSecondaryAdd === true) ? (
                    <InputWrapperDrop>
                      <SelectOptionMainWrapper>{titleComponent}</SelectOptionMainWrapper>
                    </InputWrapperDrop>
                  ) : (
                    <InputWrapperGraded>{titleComponent}</InputWrapperGraded>
                  )
                )}
              </FormItem>
            </WrapLabel>
          </Col>
        </Row>
        <RowWrapper>
          <Row gutter={24}>
            <Col lg={{ span: 7 }} md={{ span: 9 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={
                    <TitleWrapper>
                      <TitleMarginTop>First Name</TitleMarginTop>
                    </TitleWrapper>
                  }
                >
                  {getFieldDecorator(`${"firstName"}` + this.advisorType, {
                    rules: [
                      {
                        type: "string"
                      }
                    ]
                  })(
                    !(this.advisorType === "Secondary" && this.props.isNewSecondaryAdd === true) ||
                      (this.userType === "primary" && this.advisorType === "Primary" && addSecondaryAdv) ? (
                      <InputWrapperGraded>
                        <InputField
                          aria-label="Enter First Name"
                          disabled
                          placeholder="Enter name"
                          value={advisorData ? advisorData.firstname : undefined}
                        />
                      </InputWrapperGraded>
                    ) : (
                      <InputWrapper>
                        <InputField
                          data-test="first-name-block"
                          aria-label="Enter First Name"
                          onBlur={e => this.focus("First Name")}
                          maxLength={150}
                          onChange={e => this.handleNameChange(e, "firstname", advisor)}
                          value={advisorData.firstname}
                          placeholder="Enter first name"

                        />
                      </InputWrapper>
                    )
                  )}
                </FormItem>
              </WrapLabel>
              {this.state.firstname ? this.state.firstname : null}
            </Col>
            <Col lg={{ span: 7 }} md={{ span: 9 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={
                    <TitleWrapper>
                      <TitleMarginTop>Middle Name (optional)</TitleMarginTop>
                    </TitleWrapper>
                  }
                >
                  {getFieldDecorator(`${"middleName"}` + this.advisorType, {
                    rules: [
                      {
                        type: "string"
                      }
                    ]
                  })(
                    !(this.advisorType === "Secondary" && this.props.isNewSecondaryAdd === true) ||
                      (this.userType === "primary" && this.advisorType === "Primary" && addSecondaryAdv) ? (
                      <InputWrapperGraded>
                        <InputField
                          aria-label="Enter Middle Name"
                          disabled
                          placeholder="Enter middle name"
                          value={advisorData ? advisorData.middlename : undefined}
                        />
                      </InputWrapperGraded>
                    ) : (
                      <InputWrapper>
                        <InputField
                          data-test="middle-name-block"
                          aria-label="Enter Middle Name"
                          onChange={e => this.handleNameChange(e, "middlename", advisor)}
                          value={advisorData.middlename !== "" ? advisorData.middlename : undefined}
                          placeholder="Enter middle name"
                        />
                      </InputWrapper>
                    )
                  )}
                </FormItem>
              </WrapLabel>
            </Col>
            <Col lg={{ span: 7 }} md={{ span: 9 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={
                    <TitleWrapper>
                      <TitleMarginTop>Last Name</TitleMarginTop>
                    </TitleWrapper>
                  }
                >
                  {getFieldDecorator(`${"lastName"}` + this.advisorType, {
                    rules: [
                      {
                        type: "string"
                      }
                    ]
                  })(
                    !(this.advisorType === "Secondary" && this.props.isNewSecondaryAdd === true) ||
                      (this.userType === "primary" && this.advisorType === "Primary" && addSecondaryAdv) ? (
                      <InputWrapperGraded>
                        <InputField
                          aria-label="Enter Last Name"
                          disabled
                          placeholder="Enter last name"
                          value={advisorData ? advisorData.lastname : undefined}

                        />
                      </InputWrapperGraded>
                    ) : (
                      <InputWrapper>
                        <InputField
                          aria-label="Enter Last Name"
                          onBlur={e => this.focus("Last Name")}
                          onChange={e => this.handleNameChange(e, "lastname", advisor)}
                          placeholder="Enter last name"
                          value={advisorData.lastname}
                        />
                      </InputWrapper>
                    )
                  )}
                </FormItem>
              </WrapLabel>
              {this.state.lastname ? this.state.lastname : null}
            </Col>
          </Row>
        </RowWrapper>
        <RowWrapper>
          <Row gutter={24}>
            <Col lg={{ span: 7 }} md={{ span: 9 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={
                    <TitleWrapper>
                      <TitleMarginTop>Suffix (optional)</TitleMarginTop>
                    </TitleWrapper>
                  }
                >
                  {getFieldDecorator(`${"suffix"}` + this.advisorType, {
                    rules: [
                      {
                        type: "string"
                      }
                    ]
                  })(
                    (this.advisorType === "Primary" && this.userType === "primary" && !addSecondaryAdv) ||
                      (this.advisorType === "Secondary" && this.userType === "secondary") ||
                      (this.advisorType === "Secondary" && this.props.isNewSecondaryAdd === true) ? (
                      <SelectOptionMainWrapper>
                        <InputWrapperDrop>{suffixComponent}</InputWrapperDrop>
                      </SelectOptionMainWrapper>
                    ) : (
                      <InputWrapperGraded>{suffixComponent}</InputWrapperGraded>
                    )
                  )}
                </FormItem>
              </WrapLabel>
            </Col>
            <Col lg={{ span: 7 }} md={{ span: 9 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={
                    <TitleWrapper>
                      <TitleMarginTop>Date of Birth</TitleMarginTop>
                    </TitleWrapper>
                  }
                >
                  {getFieldDecorator(`${"dob"}` + this.advisorType)(
                    !(this.advisorType === "Secondary" && this.props.isNewSecondaryAdd === true) ||
                      (this.userType === "primary" && this.advisorType === "Primary" && addSecondaryAdv) ? (
                      <InputWrapperGraded>
                        <CalenderDisabling
                          aria-label="Date of Birth"
                          format="MM/DD/YYYY"
                          disabled
                          value={advisorData && advisorData.dob ? moment(advisorData.dob, "MM/DD/YYYY") : undefined}
                        />
                      </InputWrapperGraded>
                    ) : (
                      <InputWrapper height="22px" className="editAdvisor-DatePicker" aria-label="dateofBirth">
                        <Calendar
                          ariaLabel="dateofBirth"
                          onBlur={e => this.onFocusDOB(e)}
                          allowClear={false}
                          placeHolder="Select date"
                          disabledDate={currentDate => currentDate.format("YYYY-MM-DD") > moment().format("YYYY-MM-DD")}
                          format="MM/DD/YYYY"
                          onChange={e => this.handleDOBChange(e, "dob", advisor)}
                          value={advisorData && advisorData.dob ? moment(advisorData.dob, "MM/DD/YYYY") : undefined}
                        />
                      </InputWrapper>
                    )
                  )}
                </FormItem>
              </WrapLabel>
              {this.state.dob ? this.state.dob : null}
            </Col>
            <Col lg={{ span: 7 }} md={{ span: 9 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={
                    <TitleWrapper>
                      <TitleMarginTop>Gender (optional)</TitleMarginTop>
                    </TitleWrapper>
                  }
                >
                  {getFieldDecorator(`${"gender"}` + this.advisorType, {
                    rules: [
                      {
                        type: "string"
                      }
                    ]
                  })(
                    !(
                      (this.advisorType === "Primary" && this.userType === "primary" && !addSecondaryAdv) ||
                      (this.advisorType === "Secondary" && this.userType === "secondary") ||
                      (this.advisorType === "Secondary" && this.props.isNewSecondaryAdd === true)
                    ) ? (
                      <InputWrapperGraded>
                        <SelectOptionGenderWrapper>
                          <Select
                            aria-label="gender"
                            role={false}
                            notFoundContent={<NoResultsWrap>No results</NoResultsWrap>}
                            showArrow={true}
                            disabled
                            defaultValue={-1}
                            value={this.genderValue === "" ? "- Select -" : this.genderValue}
                          >
                            {this.props.genderDropDown
                              ? this.props.genderDropDown.map(freq => (
                                  <Select.Option value={freq.desc}>{freq.desc}</Select.Option>
                                ))
                              : null}
                          </Select>
                        </SelectOptionGenderWrapper>
                      </InputWrapperGraded>
                    ) : (
                      <InputWrapperDrop>
                        <SelectOptionMainWrapper>
                          <SelectdropwownStyles>
                            <div
                              id={"genderABC" + this.advisorType + this.genderValue}
                              style={{ position: "relative" }}
                            >
                              <Select
                                aria-label="gender"
                                role={false}
                                getPopupContainer={() =>
                                  document.getElementById("genderABC" + this.advisorType + this.genderValue)
                                }
                                role={false}
                                defaultActiveFirstOption={false}
                                notFoundContent={<NoResultsWrap>No results</NoResultsWrap>}
                                placeholder="Select gender"
                                value={this.genderValue === "" ? "- Select -" : this.genderValue}
                                onChange={e => this.handleSelectChange(e, "gender", advisor)}
                                onSearch={e => this.handleSelectChange(e, "gender", advisor)}
                              >
                                {this.props.genderDropDown
                                  ? this.props.genderDropDown.map((freq, index) => (
                                      <Select.Option value={freq.desc} key={freq.desc + index}>
                                        <SelectOptionWrapper>{freq.desc}</SelectOptionWrapper>
                                      </Select.Option>
                                    ))
                                  : null}
                              </Select>
                            </div>
                          </SelectdropwownStyles>
                        </SelectOptionMainWrapper>
                      </InputWrapperDrop>
                    )
                  )}
                </FormItem>
              </WrapLabel>
              {this.state.gender ? this.state.gender : null}
            </Col>
          </Row>
        </RowWrapper>
        <RowWrapper>
          <Row gutter={24}>
            <Col lg={{ span: 7 }} md={{ span: 9 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={
                    <TitleWrapper>
                      <TitleTextWrapper>Last 4 digits of Social Security Number / PIN</TitleTextWrapper>
                    </TitleWrapper>
                  }
                >
                  {getFieldDecorator(`${"pin"}` + this.advisorType, {
                    rules: [
                      {
                        type: "string"
                      }
                    ]
                  })(
                    !(
                      (this.advisorType === "Primary" && this.userType === "primary" && !addSecondaryAdv) ||
                      (this.advisorType === "Secondary" && this.userType === "secondary") ||
                      (this.advisorType === "Secondary" && this.props.isNewSecondaryAdd === true)
                    ) ? (
                      <InputWrapperGraded>
                        <SecurityNumWrap>
                          <Tooltip placement="bottom" title={this.text}>
                            <Input.Password
                              aria-label="Enter SSN/PIN"
                              disabled
                              placeholder="Last four digits only"
                              value={advisorData && advisorData.ssn ? advisorData.ssn : undefined}
                            />
                          </Tooltip>
                        </SecurityNumWrap>
                      </InputWrapperGraded>
                    ) : (
                      <InputWrapper>
                        <SecurityNumWrap>
                          <Tooltip placement="bottom" title={this.text}>
                            <Input.Password
                              aria-label="Enter SSN/PIN"
                              onBlur={e => this.focus("ssn")}
                              showSearch="false"
                              maxLength={4}
                              onChange={e => this.handleNameChange(e, "ssn", advisor)}
                              value={advisorData.ssn}
                              placeholder="Last four digits Only"
                            />
                          </Tooltip>
                        </SecurityNumWrap>
                      </InputWrapper>
                    )
                  )}
                </FormItem>
              </WrapLabel>
              {this.state.ssn ? this.state.ssn : null}
            </Col>
            <Col lg={{ span: 7 }} md={{ span: 9 }}>
              <WrapLabel>
                <FormItem
                  colon={false}
                  label={
                    <TitleWrapper>
                      <TitleTextWrapper>Confirm last 4 digits of Social Security Number / PIN</TitleTextWrapper>
                    </TitleWrapper>
                  }
                >
                  {getFieldDecorator(`${"ssn"}` + this.advisorType, {
                    rules: [
                      {
                        type: "string"
                      }
                    ]
                  })(
                    !(
                      (this.advisorType === "Primary" && this.userType === "primary" && !addSecondaryAdv) ||
                      (this.advisorType === "Secondary" && this.userType === "secondary") ||
                      (this.advisorType === "Secondary" && this.props.isNewSecondaryAdd === true)
                    ) ? (
                      <InputWrapperGraded>
                        <SecurityNumWrap>
                          <Input.Password
                            aria-label="Confirm SSN/PIN"
                            disabled
                            placeholder="Last four digits only"
                            value={advisorData && advisorData.ssn !== "" ? advisorData.ssn : undefined}
                          />
                        </SecurityNumWrap>
                      </InputWrapperGraded>
                    ) : (
                      <InputWrapper>
                        <SecurityNumWrap>
                          <Input.Password
                            aria-label="Confirm SSN/PIN"
                            onBlur={e => this.focus("confirmSSN")}
                            onChange={e => this.handleNameChange(e, "confirmSSN", advisor)}
                            value={advisorData.confirmSSN}
                            placeholder="Last four digits only"
                          />
                        </SecurityNumWrap>
                      </InputWrapper>
                    )
                  )}
                </FormItem>
              </WrapLabel>
              {this.state.confirmSSN ? this.state.confirmSSN : null}
            </Col>
          </Row>
        </RowWrapper>
      </div>
    );
  }
}



const descvalueShape = PropTypes.shape({
  desc: PropTypes.string,
  value: PropTypes.string
})

userInfoForm.propTypes = {
  addSecondaryAdv: PropTypes.bool,
  advisorType: PropTypes.string,
  disableReset: PropTypes.func,
  enableResetButton: PropTypes.func,
  form: PropTypes.object,
  genderDropDown: PropTypes.arrayOf(descvalueShape),
  handleInfoChange: PropTypes.func,
  hasOwnProperty: PropTypes.func,
  isNewSecondaryAdd: PropTypes.bool,
  isStep1Edit: PropTypes.any,
  primaryInfo: PropTypes.shape({
    confirmSSN: PropTypes.string,
    deliveryMethod: PropTypes.string,
    dob: PropTypes.string,
    firstname: PropTypes.string,
    gender: PropTypes.string,
    lastname: PropTypes.string,
    middlename: PropTypes.any,
    ssn: PropTypes.string,
    suffix: PropTypes.string,
    title: PropTypes.string
  }),
  resetErrors: PropTypes.bool,
  savePrimaryInfo: PropTypes.func,
  secondaryInfo: PropTypes.shape({
    confirmSSN: PropTypes.string,
    deliveryMethod: PropTypes.string,
    dob: PropTypes.string,
    firstname: PropTypes.string,
    gender: PropTypes.string,
    key: PropTypes.number,
    lastname: PropTypes.string,
    middlename: PropTypes.any,
    ssn: PropTypes.string,
    suffix: PropTypes.string,
    title: PropTypes.string
  }),
  suffixDropDown: PropTypes.arrayOf(descvalueShape),
    tempData: PropTypes.shape({
    tempJSON: PropTypes.shape({
      advisors: PropTypes.any
    })
  }),
  titleDropDown: PropTypes.arrayOf(descvalueShape),
  userType: PropTypes.string
};
 
const WrappedUserInfoForm = Form.create({ name: "userInfo" })(userInfoForm);
 
const mapStateToProps = state => ({
 primaryInfo: state.getIn(["myAccount", "primaryAdvisor", "info"]),
 secondaryInfo: state.getIn(["myAccount", "secondaryAdvisor", "info"]),
 titleDropDown: state.getIn(["myAccount","dropdownValues","data","title"]),
 suffixDropDown: state.getIn(["myAccount","dropdownValues","data","suffix"]),
 genderDropDown: state.getIn(["myAccount","dropdownValues","data","gender"]),
 isStep1Edit: state.getIn(["myAccount","isStep1Edit","isStep1Edit","isStep1Edit"]),
 tempData: state.getIn(["myAccount", "tempJSON", "tempJSON"]) 
});
 
export const mapDispatchToProps = dispatch => {
 return {
   prefillValuesInfoPrimary: arr =>
     dispatch(prefillValuesInfoPrimary(arr)),
   prefillValuesInfoSecondary: arr =>
     dispatch(prefillValuesInfoSecondary(arr)),
   handleInfoChange: arr => dispatch(handleInfoChange(arr)),
   savePrimaryInfo: arr => dispatch(savePrimaryInfo(arr)),
   jsonTemp: val => dispatch(jsonTemp(val))
 };
};
 
export default connect(mapStateToProps,mapDispatchToProps)(WrappedUserInfoForm);

